var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdfBox"},[_c('div',{staticClass:"topBox",on:{"click":function($event){$event.stopPropagation();}}},[_vm._v("\n    可通过 Ctrl+F键 快速查询并定位内容,或者 Ctrl+鼠标滚轮 进行放大缩小\n  ")]),_c('iframe',{ref:"iframe",staticStyle:{"position":"absolute"},attrs:{"height":"100%","width":"100%","src":"/pdf/illustrate.pdf","frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }